import extensions from './extensions';

export default {
  extensions,
};
